import { useContext } from 'react';

import { MessageContext } from '@/helpers/MessageProvider';
import useTelemetryData from '@/hooks/useTelemetryData';

const useCalibrationCommand = () => {
  const { publishCommand } = useContext(MessageContext);
  const { getAddress } = useTelemetryData();

  const accelerometerNext = (robot) => {
    const address = getAddress(robot.id);
    publishCommand(robot, 'calibration/accelerometer/next', [[...address]]);
  };

  const accelerometerStart = (robot) => {
    const address = getAddress(robot.id);
    publishCommand(robot, 'calibration/accelerometer/start', [[...address]]);
  };

  const compassCancel = (robot) => {
    const address = getAddress(robot.id);
    publishCommand(robot, 'calibration/compass/cancel', [[...address]]);
  };

  const compassStart = (robot) => {
    const address = getAddress(robot.id);
    publishCommand(robot, 'calibration/compass/start', [[...address]]);
  };

  const gyroscope = (robot) => {
    const address = getAddress(robot.id);
    publishCommand(robot, 'calibration/gyroscope', [[...address]]);
  };

  const levelHorizon = (robot) => {
    const address = getAddress(robot.id);
    publishCommand(robot, 'calibration/level_horizon', [[...address]]);
  };

  const reboot = (robot) => {
    const address = getAddress(robot.id);
    publishCommand(robot, 'calibration/reboot', [[...address]]);
  };

  return {
    accelerometerNext,
    accelerometerStart,
    compassCancel,
    compassStart,
    gyroscope,
    levelHorizon,
    reboot,
  };
};

export default useCalibrationCommand;
